module.exports = __webpack_public_path__ + "img/cmp-tab-active-history.f7d7b944.svg";